import { ButtonProps } from '../../atoms/Button';
import { DividerProps } from '../../atoms/Divider';
import { TextProps } from '../../atoms/Text';


type StudentCourseDetailsFooterInternalProps = {
  divider?: DividerProps;
  text?: TextProps;
  button?: ButtonProps;
};

type StudentCourseDetailsFooterPropsValues = {
  '': StudentCourseDetailsFooterInternalProps;
};

const propValues: StudentCourseDetailsFooterPropsValues = {
  '': {
    divider: {
      type: 'Horizontal',
      style: 'Solid',
      colour: 'BorderBase',
    },
    text: {
      style: 'Bold',
      align: 'Left',
      colour: 'Default',
      type: 'Heading4',
    },
    button: {
      style: 'Contained',
      size: 'Large',
      type: 'Text',
      colour: 'PrimaryAction',
      loading: 'Default',
    },
  },
};

const getProps = (type: string): StudentCourseDetailsFooterInternalProps => {
  const values: StudentCourseDetailsFooterInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
